
const projects = [
    {
        title: "Zimujące bociany białe",
        content: "Stado bocianów białych liczące ponad 300 osobników, które nie były w stanie podjąć wędrówki migracyjnej w zeszłym sezonie. Podczas okresu zimowego są odpowiednio leczone i rehabilitowane tak, aby z nadejściem wiosny opuścić teren Ośrodka.",
        imageSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/1230x615/15.jpg",
        thumbnailSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/615x615/15.jpg"
    },
    {
        title: "Pogotowie dla niedźwiedzi",
        content: "Celem przedsięwzięcia jest stworzenie profesjonalnego budynku i wybiegu dla niedźwiedzi brunatnych. W Polsce nie ma miejsca w którym mogłyby być leczone i rehabilitowane niedźwiedzie w celu przywrócenia ich do natury. Ośrodek jako nieliczna taka placówka w Europie byłby w stanie przyjmować te dzikie zwierzęta i pomagać im w tym, aby nie były „atrakcją” w ogrodzie zoologicznym bez możliwości życia w zgodzie z ich naturą. Dzięki wybudowanemu tarasowi widokowemu możliwe będzie obserwowanie niedźwiedzi w ich naturalnym środowisku. Będzie to jedyny tego typu obiekt edukacji przyrodniczej w Polsce.",
        imageSource: null,
        thumbnailSource: null
    },
    {
        title: "Pogotowie dla saren",
        content: "Tworzenie zaplecza do ratowania, leczenia i późniejszej rehabilitacji Saren europejskich, ofiar wypadków komunikacyjnych. Organizowanie interwencji (także zdarzeń kłusowniczych), w których ucierpiały rannych osobników. Długotrwałe leczenie i rehabilitacja.",
        imageSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/1230x615/13.jpg",
        thumbnailSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/615x615/13.jpg"
    },
    {
        title: "Ambulatorium dla jeży",
        content: "Kampania na rzecz stworzenia profesjonalnego zaplecza medyczno-rehabilitacyjno-opiekuńczego pod nazwą Ambulatorium dla JEŻY. Aby zapewnić jeżom bezpieczny powrót do środowiska naturalnego konieczne jest rehabilitowanie ich w odpowiednich warunkach. Na rzecz tego celu prowadzona jest zbiórka pieniężna pod tą sama nazwą oraz kampania informacyjno- edukacyjna w mediach społecznościowych. W 2018 roku przyjęto 39 jeży, z czego 32 powróciły do środowiska naturalnego.",
        imageSource: null,
        thumbnailSource: null
    },
    {
        title: "Sarnie przedszkole",
        content: "Wychowanie porzuconych sarenek, które trafiają do ośrodka. Przygotowanie pożywienia, szkolenie wolontariuszy i opiekunów. Rehabilitacja tak aby mogły powrócić do środowiska naturalnego. Edukacja dzieci i młodzieży mająca na celu wyeliminowanie niepotrzebnych interwencji (większość saren jest zabierana bez potrzeby), przekazanie im informacji na temat fizjologii życia i behawioru tych zwierząt.",
        imageSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/1230x615/5.jpg",
        thumbnailSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/615x615/5.jpg"
    },
    {
        title: "Bociania szkółka latania",
        content: "Stworzenie warunków do odbycia lęgów przez pary zupełnie kalekich bocianów, a następnie odchowanie młodych i przystosowanie ich do wrześniowych odlotów.",
        imageSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/1230x615/8.jpg",
        thumbnailSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/615x615/8.jpg"
    },
    {
        title: "Pogotowie dla rysi",
        content: "stworzenie zaplecza oraz wypracowanie procedur w udzielaniu skutecznej pomocy osobnikom Rysia karpackiego. Przygotowanie do interwencji w terenie.",
        imageSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/1230x615/rys.jpg",
        thumbnailSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/615x615/RYS_MALY.jpg",
    },


];


const youtubeVideos = [
    {
        title: "Bociany - Cud Narodzin",
        id: "vc6XY8Ftu-M",
        description: "No bociany się rodzą, nie wiem co tu mam opisywać. Obejrzyjta se."
    },
    {
        title: "Pogotowie dla Niedźwiedzi - III odcinek Podróży z Wielką Niedźwiedzicą",
        id: "BSNn1Yk9iKU",
        description: "Brak Opisu"
    },
    {
        title: "Na ratunek dwumiesięcznej niedźwiedzicy",
        id: "M6HW73dCu1k",
        description: "No taki mały niedzwiadek, nie wiem co tu mam opisywać. Obejrzyjta se."
    }
];

const stories = [
    {
        title: "Pierwsza Historia",
        imageSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/baner_1400x400/ptaszki3.jpg",
        thumbnailSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/350x350/ptaszki3.jpg"
    },
    {
        title: "Druga Historia",
        imageSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/baner_1400x400/ptaszki2.jpg",
        thumbnailSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/350x350/ptaszki2.jpg"
    },
    // {
    //     title: "Trzecia Historia",
    //     imageSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/kruk.jpg",
    //     thumbnailSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/kruk_thumbnail.jpg"
    // }
];

const about = {
    title: "O Ośrodku",
    imageSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/1230x615/1.jpg",
    thumbnailSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/615x615/1.jpg",
    paragraphs: [
        "Fundacja Ośrodek Rehabilitacji Zwierząt Chronionych zajmuje się niesieniem pomocy chorym, bezdomnym i osieroconym zwierzętom dzikim oraz udomowionym",
        "W Ośrodku na schronienie może liczyć każde potrzebujące zwierzę. Fundacja ma na celu zapewnić mu potrzebne leczenie, rehabilitację i pomoc w powrocie na łono natury lub znalezieniu domu adopcyjnego.",
        "Ośrodek Rehabilitacji Zwierząt Chronionych jest marką rozpoznawalną dzięki prowadzonej działalności statutowej przez ostatnie 10 lat.",
        "Ośrodek stale ulepsza kampanie mające na celu gromadzenie funduszy na konkretne przedsięwzięcia związane z ratowaniem dzikich zwierząt:"
    ]
};

const patients = [
    {
        name: "Eliot",
        story: "Czy pies może przeżyć zderzenie z tirem? Eliot jest tego żywym przykładem. Jest on ofiarą wypadku komunikacyjnego. Kałuża krwi i zmasakrowana czaszka ledwo przypominały psa. Długa reanimacja i tamowanie krwotoku nie odbierały nadziei na ratowanie życie psiaka. Udało się.",
        imageSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/eliot2.jpg"
    },
    {
        name: "Nancy i Boo",
        story: "Nancy i Boo – nużyca, świerzb, grzybica… Czy gdzieś pod tą warstwą chorób jest pies? Nasz zespół długo walczył. Jednak walka ta okazała się zwycięska i dwa skrajnie zaniedbane psiaki zamieniły się w dwa urocze maleństwa.",
        imageSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/nancy_i_boo.jpg"
    },
    {
        name: "Strupek",
        story: "Strupek w chwili gdy trafił pod naszą opiekę ledwo przypominał psa. Z kości płatami schodziła skóra pokryta strupami. Każdy dotyk, nawet najdelikatniejszy, powodował krwawienie i kolejne rany. Całodobowa opieka, co godzinę podawane środki specjalistyczne, później także specjalistyczne kąpiele. Sierść pojawiła się po kilkumiesięcznym leczeniu. Jak wygląda Strupek teraz? Piękny pies o zadbanej sierści, który rok w rok spędza wakacje ze swoją nową rodziną w Bieszczadach.",
        imageSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/strupek1.jpg"
    },
    {
        name: "Forest",
        story: "To jeden z wielu naszych pacjentów. Historia jego cierpienia ma początek w ludzkiej brutalności. Pies został znaleziony w lesie we wnykach. Wycieńczony, zagłodzony i umierający z bólu leżał w śniegu. Jego historia wstrząsnęła całą Polskę, ale także inne kraje. Amputacja dwóch łap, długotrwałe i kosztowne leczenie, wstawienie sztucznych protez oraz ciągła rehabilitacja poruszyła ludzi na całym świecie.",
        imageSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/forest2.jpg"
    },
    {
        name: "Bajo",
        story: "Pies trafił do nas w opłakanym stanie. Został odebrany od właścicieli, którzy doprowadzili go do tak tragicznego stanu. Jego skórę pokrywały strupy i świeże rany z których sączyła się krew i ropa. Na jego ciele nie było nawet kawałka zdrowej skóry. Ilość ran była tak ogromna, że doprowadziły do zniekształcenia nosa. Zalane ropą oczy były ledwo widoczne. Bajo nie był w stanie ustać na łapach. Już po kilku tygodniach intensywnej, całodobowej opieki weterynaryjnej pies odzyskał siły by stać na własnych łapach, rany powoli się goją, a strumienie ropy nie przysłaniają mu świata. Leczenie psa trwa dalej.",
        imageSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/bajo2.jpg"
    },
    {
        name: "Oczko",
        story: "To kolejna ofiara ludzkiej brutalności. Pies był katowany przez człowieka. Wielokrotnie bity tępym, płaskim przedmiotem. Najwięcej ciosów otrzymał w głowę. Potrzaskana czaszka i wylewające się gałki oczne. Niestety wzroku psa nie udało się uratować. Po długim leczeniu i rehabilitacji pies powrócił do sprawności i znalazł nowego opiekuna.",
        imageSource: "https://orzw-resources.s3.eu-central-1.amazonaws.com/oczko2.jpg"
    }
];


export function getPatients() {
    return patients;
}

export function getProjects() {
    return projects;
}

export function getYtVideos() {
    return youtubeVideos;
}

export function getStories() {
    return stories;
}

export function getAbout() {
    return about;
}